import isString from './isString';

const saveBlobAsFile = (blob: Blob | string, filename: string) => {
    const a = document.createElement('a');
    a.download = filename;
    a.href = isString(blob) ? blob : URL.createObjectURL(blob);

    a.style.display = 'none';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => {
        URL.revokeObjectURL(a.href);
    }, 1500);
};

export default saveBlobAsFile;
